import React, { useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";
import { useGetCheckoutListDataMutation, useGetCheckoutInfoDataMutation } from "../../../features/supplyBeam/supplyBeamData/checkoutListAPI";
import { useGetLocationListDataMutation } from "../../../features/supplyBeam/supplyBeamData/checkinListAPI";
import { getLoginUserData } from "../../../utils/getLoginUserData";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";

function objectsAreEqual(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    for (let key of keys1) {
        if (!obj2.hasOwnProperty(key)) return false;
        if (obj1[key] !== obj2[key]) return false;
    }
    return true;
}


const CheckoutList = () => {
    const zoneId = getLoginUserData().zone_id;

    const [
        fetchCheckoutList,
        {
            data: checkoutListData,
            error: checkoutListError,
            isLoading: checkoutListIsLoading,
        },
    ] = useGetCheckoutListDataMutation();

    const [
        fetchCheckoutInfo,
        {
            data: checkoutInfoData,
            error: checkoutInfoError,
            isLoading: checkoutInfoIsLoading,
        },
    ] = useGetCheckoutInfoDataMutation();

    const [myList, setMyList] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationResetToggle, setPaginationResetToggle] = useState(false);

    const appUserTypes = JSON.parse(sessionStorage.getItem("appUserType"));
    const [appUsers, setAppUsers] = useState(appUserTypes);
    const [userTypesArray, setUserTypesArray] = useState({
        name: "All",
        id: null,
    });
    const [userTypeId, setUserTypeId] = useState(userTypesArray.id);

    // Modal state
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [selectedRef, setSelectedRef] = useState("");

    const initialRequest = {
        user_type_id: userTypeId,
        name: "",
        limit: 10,
        offset: 0,
        product_code: "",
        batch_running_code: "",
        product_name: "",
        mobile: "",
        start_date: "",
        end_date: "",
        ref: "",
        out_code: "",
        location_id: "",
        zoneId,
        tenant:true
    };

    const initialRequestCount = {
        user_type_id: userTypeId,
        name: "",
        product_code: "",
        batch_running_code: "",
        product_name: "",
        mobile: "",
        start_date: "",
        end_date: "",
        ref: "",
        out_code: "",
        location_id: "",
        zoneId,
        tenant:true
    };

    const [request, setRequest] = useState(initialRequest);
    const [requestCount, setRequestCount] = useState(initialRequestCount);
    const [locations, setLocations] = useState([]);

    const [fetchLocations] = useGetLocationListDataMutation();

    useEffect(() => {
        const loadLocations = async () => {
            try {
                const response = await fetchLocations({
                    token: sessionStorage.getItem("access_token"),
                    tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
                    body: {},
                }).unwrap();
                if (response && response.data) {
                    setLocations(response.data);
                }
            } catch (err) {
                console.error("Failed to fetch locations", err);
            }
        };
        loadLocations();
    }, []);

    const clearFilters = () => {
        setRequest(initialRequest);
        setRequestCount(initialRequestCount);
    };

    useMemo(() => {
        for (let index = 0; index < appUsers.length; index++) {
            const element = appUsers[index];
            if (
                element.user_type.toLocaleLowerCase() ===
                userTypesArray?.name?.toLocaleLowerCase()
            ) {
                setUserTypeId(element.user_type_id);
                setRequest((prevRequest) => ({
                    ...prevRequest,
                    user_type_id: +element.user_type_id,
                }));
                break;
            }
        }
    }, [userTypesArray]);

    useEffect(() => {
        fetchCheckoutListFunction();

        let tempRequest = { ...request };
        delete tempRequest.limit;
        delete tempRequest.offset;

        if (!objectsAreEqual(tempRequest, requestCount)) {
            setRequestCount(tempRequest);
        }
    }, [request]);

    const fetchCheckoutListFunction = () => {
        fetchCheckoutList({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            data: request,
        });
    };

    const [csvData, setCsvData] = useState(null);

    useEffect(() => {
        if (checkoutListData) {
            console.log("success checkout list", checkoutListData);
            setMyList(checkoutListData && checkoutListData.data ? checkoutListData.data : []);
        }
        if (checkoutListError) {
            toast.dismiss();
            toast.error("Something went wrong", { id: "checkoutListError" });
        }
    }, [checkoutListData, checkoutListError]);

    // Handle checkout info response (for modal)
    useEffect(() => {
        if (checkoutInfoData) {
            console.log("success checkout info", checkoutInfoData);
            setModalData(checkoutInfoData && checkoutInfoData.data ? checkoutInfoData.data : []);
        }
        if (checkoutInfoError) {
            toast.dismiss();
            toast.error("Failed to fetch QR details", { id: "checkoutInfoError" });
        }
    }, [checkoutInfoData, checkoutInfoError]);

    const handleViewClick = (row) => {
        setSelectedRef(row.ref);
        setShowModal(true);
        fetchCheckoutInfo({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: { id: row.id },
        });
    };

    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * limit;
        setOffset(newOffset);
        setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
        setCurrentPage(pageNumber);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setRequest((prevRequest) => ({
          ...prevRequest,
          limit: newPerPage,
          offset: 0,
        }));
        setLimit(newPerPage);
    setOffset(0);
        setCurrentPage(1);
        setPaginationResetToggle((prev) => !prev);

    };

    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => offset + Number(idx + 1),
            sortable: true,
            width: "80px",
        },
        {
            name: "Ref",
            cell: (row) => row.ref,
            sortable: true,
            width: "220px",
        },
        {
            name: "User Name",
            cell: (row) => row.user_name,
            sortable: true,
            width: "120px",
        },
        {
            name: "User Type",
            cell: (row) => row.user_type + " " + "User",
            sortable: true, 
            width: "120px",
        },
        
        {
            name: "Checkout Out Name",
            cell: (row) => row.out_name,
            sortable: true,
            width: "220px",
        },
        {
            name: "Checkout to Code",
            cell: (row) => row.out_code,
            sortable: true,
            width: "220px",
        },
        {
            name: "Total Count",
            cell: (row) => row.total_count,
            sortable: true,
            width: "120px",
        },
        {
            name: "Created At",
            cell: (row) => new Date(row.created_at).toLocaleString(),
            width: "200px",
            sortable: true,
        },
        {
            name: "Action",
            cell: (row) => (
                <button
                    className="rounded bg-blue-600 px-3 py-1 text-sm text-white hover:bg-blue-700"
                    onClick={() => handleViewClick(row)}
                >
                    View
                </button>
            ),
            width: "100px",
        },
    ];

    // Modal table columns for checkout_qrs
    const modalColumns = [
        {
            name: "SNo",
            cell: (row, idx) => Number(idx + 1),
            sortable: true,
            width: "80px",
        },
        {
            name: "Product Code",
            cell: (row) => row.product_code,
            sortable: true,
            width: "150px",
        },
        {
            name: "Product Name",
            cell: (row) => row.name,
            sortable: true,
            width: "220px",
        },
        {
            name: "Batch Running Code",
            cell: (row) => row.batch_running_code,
            sortable: true,
            width: "200px",
        },
        {
            name: "QR Type",
            cell: (row) => row.qr_type_text,
            sortable: true,
            width: "120px",
        },
    ];

    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full ">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        Checkout List
                        <LinksComponent />
                    </div>

                    <div className="p-3">
                        <div className=" w-full bg-white shadow rounded-lg">
                            <div className="">
                                <DataTableComponent
                                    keyField={(row) => row.SNo}
                                    columns={columns}
                                    data={myList}
                                    totalRows={totalRows}
                                    handlePerRowsChange={handlePerRowsChange}
                                    handlePageChange={handlePageChange}
                                    paginationDefaultPage={currentPage}
                                    paginationResetDefaultPage={paginationResetToggle}
                                >
                                    <div className="bg-gray-50 border-b border-gray-200 p-4">
                                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 items-end">
                                            <div className="flex flex-col">
                                                <label className="text-xs font-semibold text-gray-600 mb-1">Reference No</label>
                                                <input
                                                    type="text"
                                                    className="border border-gray-300 rounded-md px-3 py-1.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                                                    placeholder="Search Ref..."
                                                    value={request.ref}
                                                    onChange={(e) =>
                                                        setRequest({ ...request, ref: e.target.value, offset: 0 })
                                                    }
                                                />
                                            </div>
                                            <div className="flex flex-col">
                                                <label className="text-xs font-semibold text-gray-600 mb-1">Out Code</label>
                                                <input
                                                    type="text"
                                                    className="border border-gray-300 rounded-md px-3 py-1.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                                                    placeholder="Search Out Code..."
                                                    value={request.out_code}
                                                    onChange={(e) =>
                                                        setRequest({ ...request, out_code: e.target.value, offset: 0 })
                                                    }
                                                />
                                            </div>
                                            <div className="flex flex-col">
                                                <label className="text-xs font-semibold text-gray-600 mb-1">Location</label>
                                                <select
                                                    className="border border-gray-300 rounded-md px-3 py-1.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-white"
                                                    value={request.location_code}
                                                    onChange={(e) =>
                                                        setRequest({ ...request, location_id: e.target.value, offset: 0 })
                                                    }
                                                >
                                                    <option value="">All Locations</option>
                                                    {console.log("+++++++++++", locations)}
                                                    {locations.map((loc) => (
                                                        <option key={loc.id} value={loc.out_code}>
                                                            {loc.location}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="flex flex-col">
                                                <label className="text-xs font-semibold text-gray-600 mb-1">From Date</label>
                                                <input
                                                    type="date"
                                                    className="border border-gray-300 rounded-md px-3 py-1.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                                                    value={request.start_date}
                                                    onChange={(e) =>
                                                        setRequest({ ...request, start_date: e.target.value, offset: 0 })
                                                    }
                                                />
                                            </div>
                                            <div className="flex flex-col">
                                                <label className="text-xs font-semibold text-gray-600 mb-1">To Date</label>
                                                <input
                                                    type="date"
                                                    className="border border-gray-300 rounded-md px-3 py-1.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                                                    value={request.end_date}
                                                    onChange={(e) =>
                                                        setRequest({ ...request, end_date: e.target.value, offset: 0 })
                                                    }
                                                />
                                            </div>
                                            <div className="flex items-end gap-2">
                                                <button
                                                    className="rounded-md bg-blue-600 px-4 py-1.5 text-sm font-semibold text-white hover:bg-blue-700 transition shadow-sm"
                                                    onClick={fetchCheckoutListFunction}
                                                >
                                                    Search
                                                </button>
                                                <button
                                                    className="rounded-md bg-gray-200 px-4 py-1.5 text-sm font-semibold text-gray-700 hover:bg-gray-300 transition"
                                                    onClick={clearFilters}
                                                >
                                                    Clear
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </DataTableComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Checkout QR Details Modal */}
            {showModal && (
                <ModalComponent
                    size={"5xl"}
                    show={showModal}
                    setShow={setShowModal}
                >
                    <div className="p-4">
                        <div className="text-lg font-semibold mb-3">
                            Checkout QR Details — <span className="text-blue-600">{selectedRef}</span>
                        </div>
                        {checkoutInfoIsLoading ? (
                            <div className="text-center py-8 text-gray-500">Loading...</div>
                        ) : modalData.length > 0 ? (
                            <DataTableComponent
                                keyField={(row) => row.SNo}
                                columns={modalColumns}
                                data={modalData}
                                totalRows={modalData.length}
                                handlePerRowsChange={() => { }}
                                handlePageChange={() => { }}
                            />
                        ) : (
                            <div className="text-center py-8 text-gray-500">No QR records found</div>
                        )}
                    </div>
                </ModalComponent>
            )}
        </>
    );
};

export default CheckoutList;
